import React, { useState, useEffect } from "react";
import "./FinancialPerformance.css";

function FinancialPerformance({ projectData = {} }) {
  const [performanceData, setPerformanceData] = useState({
    billingProgress: 0,
    costPerformance: 0,
    actualRevenue: 0,
    revisedRevenue: 0,
    actualExpense: 0,
    revisedExpense: 0
  });

  useEffect(() => {
    const fetchFinancialData = async () => {
      if (!projectData?.projectId || !projectData?.division) return;

      try {
        const response = await fetch(
          `https://projects-dev.nettlescs.com:5000/api/finicial-budget?projectID=${projectData.projectId}&divisionName=${projectData.division}`
        );
        const data = await response.json();

        // Find the values from budgetProgressData array
        const findValue = (label) => {
          const item = data.budgetProgressData.find(item => item.label === label);
          return item ? parseFloat(item.value) : 0;
        };

        setPerformanceData({
          billingProgress: findValue("Billing Progress"),
          costPerformance: findValue("Cost Performance"),
          actualRevenue: findValue("Actual Revenue Amount"),
          revisedRevenue: findValue("Revised Revenue Budget"),
          actualExpense: findValue("Actual Expense Amount"),
          revisedExpense: findValue("Revised Budget Expense")
        });
      } catch (error) {
        console.error('Error fetching financial data:', error);
      }
    };

    fetchFinancialData();
  }, [projectData?.projectId, projectData?.division]);

  // Helper function to format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <section className="financial-performance">
      <div className="performance-header">
        <h2 className="performance-title">Financial Performance</h2>
        <div className="legend">
          <div className="legend-item">
            <div className="legend-color billed"></div>
            <div className="legend-label">Billed to Date</div>
          </div>
          <div className="legend-item">
            <div className="legend-color total"></div>
            <div className="legend-label">Total Contract</div>
          </div>
        </div>
      </div>
      <div className="performance-metrics">
        <div className="metric">
          <h3 className="metric-title">Billing Progress</h3>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${performanceData.billingProgress}%` }}
              aria-label={`Billing progress: ${performanceData.billingProgress}%`}
            ></div>
          </div>
          <div className="progress-values">
            <div className="progress-start">{formatCurrency(performanceData.actualRevenue)}</div>
            <div className="progress-end">{formatCurrency(performanceData.revisedRevenue)}</div>
          </div>
        </div>
        <div className="metric">
          <h3 className="metric-title">Cost Performance</h3>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${performanceData.costPerformance}%` }}
              aria-label={`Cost performance: ${performanceData.costPerformance}%`}
            ></div>
          </div>
          <div className="progress-values">
            <div className="progress-start">{formatCurrency(performanceData.actualExpense)}</div>
            <div className="progress-end">{formatCurrency(performanceData.revisedExpense)}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FinancialPerformance;